<template>
  <div class="report">
    <div class="port-head">
      <div class="title">
        <span @click="changePort" class="van-ellipsis">{{
          mapValidCourseList[formInfoId] ? mapValidCourseList[formInfoId].name : ''
        }}</span>
        <i @click="changePort" class="iconfont icon-arrow-down-copy"></i>
      </div>
      <div class="result-container">
        <div class="result">
          <div class="item">
            <p>{{ countAnswerUser }}</p>
            <span>参与评课人数</span>
          </div>
          <div class="line"></div>
          <div class="item">
            <p>{{ totalAvgPint }}</p>
            <span>得分(满分:{{ this.detail[0] ? this.detail[0].paperTotalPoint : 0 }})</span>
          </div>
        </div>
      </div>
    </div>
    <ul class="tab">
      <li @click="changeTab(1)" :class="{active: tabIndex === 1}">评课详情</li>
      <li @click="changeTab(2)" :class="{active: tabIndex === 2}">专家点评</li>
    </ul>
    <div v-if="tabIndex === 1" class="tab-one">
      <div class="tab-one-item" v-for="(item, index) in detail" :key="index">
        <div class="title">{{ item.label }}</div>
        <template v-if="item.options">
          <div class="content" v-for="(subItem, j) in item.options" :key="j">
            <div class="subTitle">{{ subItem.label }}</div>
            <div class="percent">
              <van-progress style="flex:1" :percentage="format(subItem.percentage)" stroke-width="10" pivot-text="" />
              <span class="percent-static">{{ subItem.percentage }}</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="percent">
            <van-progress style="flex:1" :percentage="format1(item)" stroke-width="10" pivot-text="" />
            <span class="percent-static"> {{ item.propValue }}分</span>
            <span class="percent-static">{{ item.total }}分</span>
          </div>
        </template>
      </div>
    </div>

    <div v-if="tabIndex === 2" class="tab-two">
      <template v-if="techAuths && techAuths.length > 0">
        <div class="tab-two-item" v-for="(item, index) in techAuths" :key="index">
          <template v-if="item.answerVos && item.answerVos.length > 0">
            <div class="head">
              <img v-if="item.userFace" :src="$isCdn(item.userFace)" alt="" />
              <img v-else :src="avatar" alt="" />
              <span class="van-ellipsis name">{{ item.name }}</span>
              <div class="van-ellipsis org">{{ item.orgName }}</div>
            </div>
            <div class="content">
              <div class="content-item" v-for="(subItem, index) in item.answerVos" :key="index">
                <template v-if="subItem.value">
                  <div class="title">{{ subItem.text }}</div>
                  <div class="answer">
                    <span v-if="subItem.type != 'rate'">{{ subItem.value }}</span>
                    <div v-else style="margin-top:10px;display:flex;align-items:center">
                      <van-rate
                        :value="Number(subItem.value)"
                        :size="25"
                        readonly
                        color="#ffd21e"
                        void-icon="star"
                        void-color="#eee"
                      />
                      <span style="margin-left:10px;color:#ffd21e">{{ subItem.value }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="no-tab2">
          <p>暂无专家点评</p>
        </div>
      </template>
    </div>

    <van-action-sheet v-model="show" title="请选择评课报告" :closeable="false">
      <div class="course-item-container">
        <div
          class="course-item van-ellipsis"
          @click="selectCourse(item)"
          v-for="(item, index) in validCourseList"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </van-action-sheet>

    <!-- <Back /> -->
  </div>
</template>

<script>
import {selectStatic, selectAnswerByText} from '@/api'
export default {
  data() {
    return {
      avatar: require('@/assets/image/avatar.svg'),
      eventId: '',
      formInfoId: '',
      tabIndex: 1,
      show: false,
      // 评课详情
      countAnswerUser: 0,
      rank: 0,
      transcend: 0,
      totalAvgPint: 0,
      detail: [],
      // 专家点评
      techAuths: []
    }
  },
  computed: {
    courseList() {
      return this.$store.state.activePlay.courseList
    },
    validCourseList() {
      if (this.courseList) {
        return this.courseList.filter(item => item.status === 2)
      }
      return []
    },
    mapValidCourseList() {
      const map = {}
      this.validCourseList.map(item => {
        map[item.formInfoId] = item
      })
      return map
    }
  },
  created() {
    const {eventId, formInfoId} = this.$route.query
    this.$store.dispatch('getCourseList', eventId)
    this.formInfoId = formInfoId
    this.eventId = eventId
    this.geTab1(formInfoId, eventId)
    this.geTab2(formInfoId, eventId)
  },
  methods: {
    changeTab(tab) {
      this.tabIndex = tab
    },
    geTab1(formInfoId, eventId) {
      selectStatic(formInfoId, eventId).then(res => {
        this.detail = res.data.detail
        this.countAnswerUser = res.data.countAnswerUser
        this.rank = res.data.rank
        this.transcend = res.data.transcend
        this.totalAvgPint = res.data.totalAvgPint
      })
    },
    geTab2(formInfoId, eventId) {
      selectAnswerByText(formInfoId, eventId).then(res => {
        this.techAuths = res.data
      })
    },
    changePort() {
      if (this.validCourseList.length === 1) return false
      this.show = true
    },
    selectCourse(item) {
      this.formInfoId = item.formInfoId
      this.geTab1(item.formInfoId, this.eventId)
      this.geTab2(item.formInfoId, this.eventId)
      this.show = false
    },
    format(val) {
      return val.replace('%', '')
    },
    format1(val) {
      const p = (val.propValue / val.total).toFixed(2) * 100
      return p
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  min-height: 100vh;
  background: #f2f2f2;
}
.port-head {
  position: relative;
  z-index: 8;
  height: 100px;
  background: #4465f3;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  .title {
    font-size: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 10px;
    > span {
      max-width: 80%;
      margin-right: 10px;
    }
  }
}
.result-container {
  z-index: 9;
  position: absolute;
  left: 0;
  right: 0;
  top: 50px;
  padding: 6px 12px 12px 12px;
  .result {
    height: 100px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.06);
    display: flex;
    align-items: center;
    justify-content: space-around;
    .line {
      width: 1px;
      height: 43px;
      background: #ededed;
    }
    .item {
      text-align: center;
      p {
        font-size: 20px;
        color: #4465f3;
        font-weight: 800;
        margin: 0;
        margin-bottom: 4px;
      }
      span {
        color: #909399;
        font-size: 12px;
      }
    }
  }
}

.tab {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 90px 50px 0;
  li {
    color: #909399;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    padding-bottom: 12px;
  }
  li.active {
    color: #303133;
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 32px;
      height: 5px;
      background: #4465f3;
      border-radius: 3px;
    }
  }
}

.tab-one {
  background: #ffffff;
  border-radius: 12px 12px 0px 0px;
  .tab-one-item {
    // margin-top: 25px;
    padding: 10px;
    .title {
      word-break: break-all;
      font-size: 16px;
      color: #303133;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .content {
      margin-top: 20px;
      .subTitle {
        word-break: break-all;
        color: #303133;
        font-size: 14px;
        margin-bottom: 5px;
      }
      .percent {
        display: flex;
        align-items: center;
        .percent-bar {
          flex: 1;
        }
        .percent-static {
          display: block;
          width: 50px;
          text-align: center;
          color: #909399;
          font-size: 14px;
        }
      }
    }
    .percent {
      display: flex;
      align-items: center;
      .percent-bar {
        flex: 1;
      }
      .percent-static {
        display: block;
        width: 50px;
        text-align: center;
        color: #909399;
        font-size: 14px;
      }
    }
  }
}

.tab-two {
  padding: 0 12px 12px;
  .tab-two-item {
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 12px;
    .head {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
      .name {
        width: 100rpx;
        padding: 0 12px;
        color: #606266;
        font-size: 14px;
      }
      .org {
        flex: 1;
        color: #909399;
        font-size: 12px;
      }
    }
    .content {
      .content-item {
        margin-bottom: 12px;
        .title {
          word-break: break-all;
        }
        .answer {
          color: #606266;
          word-break: break-all;
        }
      }
    }
  }
}
.no-tab2 {
  margin-top: 10px;
  text-align: center;
  p {
    color: #333;
  }
}

.course-item-container {
  max-height: 40vh;
  overflow-y: scroll;
}
.course-item {
  text-align: center;
  padding: 20px 15%;
  border-top: 1px solid #eee;
}
</style>
